import { FeatureDetection } from './'

let $targetElement = null

const scrollToThisElement = (offset = 0) => {
  const elementPosition = $targetElement.getBoundingClientRect().top - offset

  if (FeatureDetection.browser.isIe() || FeatureDetection.os.isAndroid()) {

    window.scrollBy(0, elementPosition)

  } else {

    window.scrollBy({
      top: elementPosition,
      left: 0,
      behavior: 'smooth'
    })

  }
}

const ScrollTo = (id, offset = 0) => {
  $targetElement = document.querySelector(id)

  if ($targetElement == null) return

  return scrollToThisElement(offset)
}

export default ScrollTo



// WEBPACK FOOTER //
// ./js/utils/ScrollTo.js